import React, { useState } from 'react';
import { format, parseISO } from 'date-fns';
import toast from 'react-hot-toast';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { archiveError, useSetArchived } from '../../hooks/useModuleArchive';

const archivedDetail = (module) =>
  [
    module.archived_at &&
      `Archived ${format(parseISO(module.archived_at), 'd MMM yyyy')}`,
    module.archived_by && `by ${module.archived_by}`,
  ]
    .filter(Boolean)
    .join(' ');

// The course's archived modules, collapsed by default, each with Unarchive.
export default function ArchivedModules({ courseId, modules }) {
  const [open, setOpen] = useState(false);
  const [busyId, setBusyId] = useState(null);
  const setArchived = useSetArchived(courseId);
  if (!modules.length) return null;

  const unarchive = (module) => {
    setBusyId(module.module_id);
    setArchived.mutate(
      { moduleId: module.module_id, archive: false },
      {
        onSuccess: () =>
          toast.success(`${module.name} is back in the course's modules.`),
        onError: (error) =>
          toast.error(archiveError(error, "We couldn't unarchive it.")),
        onSettled: () => setBusyId(null),
      }
    );
  };

  return (
    <section className="mx-2 rounded-lg bg-white">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="flex w-full items-center justify-between px-4 py-3 text-sm text-gray-700"
      >
        <span>Archived modules ({modules.length})</span>
        {open ? (
          <ExpandLessIcon fontSize="small" />
        ) : (
          <ExpandMoreIcon fontSize="small" />
        )}
      </button>
      {open && (
        <ul className="m-0 list-none divide-y divide-gray-100 border-t border-gray-100 p-0">
          {modules.map((module) => (
            <li
              key={module.module_id}
              className="flex items-center justify-between gap-3 px-4 py-2"
            >
              <div className="min-w-0">
                <p className="truncate text-sm text-gray-900">{module.name}</p>
                <p className="text-xs text-gray-500">
                  {archivedDetail(module) || 'Archived'}
                </p>
              </div>
              <button
                type="button"
                onClick={() => unarchive(module)}
                disabled={busyId !== null}
                className="shrink-0 rounded-md border border-claret-500 px-3 py-1 text-xs text-claret-500 hover:bg-gray-50 disabled:opacity-50"
              >
                {busyId === module.module_id ? 'Unarchiving…' : 'Unarchive'}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
